/**
 * Handle notification permission flow and persistence.
 */
import type { Settings } from '../../modules/types';
import type { SettingsHandlerDeps } from './types';

export async function applyNotificationPreferences(
  deps: SettingsHandlerDeps,
  settings: Settings
): Promise<void> {
  const { els, showToast } = deps;

  if (!els.settingsEnableNotifications) return;

  let enableRequested = els.settingsEnableNotifications.checked;

  if (enableRequested) {
    if (typeof Notification === 'undefined') {
      showToast('Browser does not support notifications.', { type: 'error' });
      enableRequested = false;
    } else if (Notification.permission === 'default') {
      try {
        const perm = await Notification.requestPermission();
        if (perm !== 'granted') {
          showToast('Notification permission denied; disabling alerts.', { type: 'warning' });
          enableRequested = false;
        }
      } catch {
        enableRequested = false;
      }
    } else if (Notification.permission === 'denied') {
      showToast('Notifications blocked by browser.', { type: 'warning' });
      enableRequested = false;
    }
  }

  settings.enableNotifications = enableRequested;
  els.settingsEnableNotifications.checked = enableRequested;

  if (els.settingsNotificationsPermissionStatus && typeof Notification !== 'undefined') {
    els.settingsNotificationsPermissionStatus.textContent = Notification.permission;
  }
}
